import React, { useState, useMemo, useEffect } from "react";

import { useApp } from "context/appContext";
import {
  getReservationInfo,
  getReservationsByDate,
  getReservationByPerson,
  getAllEventsByDate,
} from "services/event.service";

const InletContext = React.createContext();

export function InletProvider(props) {
  const [groupId, setGroupId] = useState("");
  const [showCamera, setShowCamera] = useState(true);
  const [loading, setLoading] = useState(false);
  const [reservation, setReservation] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [bookings, setBookings] = useState([]);
  const { showNotification } = useApp();
  const [events, setEvents] = useState([]);

  useEffect(() => {
    async function getBookings() {
      setLoading(true);
      try {
        const date = getDate();
        const [reservationInfo, eventsInfo] = await Promise.all([
          getReservationsByDate(date),
          getAllEventsByDate(date),
        ]);
        setBookings(reservationInfo);
        setEvents(eventsInfo);
      } catch (err) {
        console.log(err.message);
        showNotification(
          "Ha ocurrido un error en la consulta de las reservas.",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }
    getBookings();
    // eslint-disable-next-line
  }, []);

  const getReservation = async (code) => {
    const booking = bookings.find((boo) => boo.code === code);
    if (booking) {
      setReservation(booking);
      setShowCamera(false);
    } else {
      setLoading(true);
      try {
        const reservationInfo = await getReservationInfo(code);
        setReservation(reservationInfo);
        setShowCamera(false);
      } catch (err) {
        console.log(err.message);
        showNotification(
          "Ha ocurrido un error en la consulta del QR.",
          "error"
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const getReservationByCC = async (values) => {
    setLoading(true);
    try {
      const reservationInfo = await getReservationByPerson(values);
      setReservation(reservationInfo);
      setShowCamera(false);
    } catch (err) {
      console.log(err.message);
      showNotification(
        "No se ha encontrado tu reserva, por favor contacta con el administrador",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const getAllReservation = async () => {
    setLoading(true);
    try {
      const reservationInfo = await getReservationsByDate(getDate());
      setBookings(reservationInfo);
    } catch (err) {
      console.log(err.message);
      showNotification(
        "Ha ocurrido un error en la consulta de las reservas.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const getDate = () => {
    var date = new Date();
    var dateString = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
      .toISOString()
      .split("T")[0];
    return dateString;
  };

  // eslint-disable-next-line
  const value = useMemo(() => {
    return {
      groupId,
      loading,
      showCamera,
      reservation,
      showSuccess,
      setReservation,
      setShowCamera,
      setGroupId,
      setLoading,
      getReservation,
      setShowSuccess,
      getAllReservation,
      setBookings,
      getReservationByCC,
      events,
    };
  });

  return <InletContext.Provider value={value} {...props} />;
}

export function useInlet() {
  const context = React.useContext(InletContext);
  if (!context) {
    throw new Error("useInlet debe estar dentro del proveedor InletContext");
  }
  return context;
}
